import PropTypes from 'prop-types';
import userTypeShape from './UserType';

const cardAccountSignupShape = PropTypes.shape({
  id: PropTypes.string,
  cardholderFirstName: PropTypes.string,
  cardholderLastName: PropTypes.string,
  cardFor: PropTypes.arrayOf(PropTypes.string),
  cardForOther: PropTypes.string,
  trustee: PropTypes.bool,
  userType: userTypeShape,
  userId: PropTypes.string,
});

export default cardAccountSignupShape;
